import { useParams } from "react-router-dom";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import { useGetParticipantTypes } from "../../../participant-types";
import { useGetProductSections, useGetProducts } from "../../../products";
import { getNavibusSchema } from "../validation/navibusSchema";

export function useNavibusQueryParams() {
    const { productTypeId } = useParams() as { productTypeId: string };
    const participantTypesQuery = useGetParticipantTypes({ productTypeId: Number(productTypeId) });
    const productsQuery = useGetProducts({ productTypeId: Number(productTypeId) });
    const productSectionsQuery = useGetProductSections(productsQuery.data?.[0].id);

    const schema = getNavibusSchema(
        participantTypesQuery.data || [],
        productSectionsQuery.data || [],
    );

    return useQueryParams(schema);
}
